module.exports = __webpack_public_path__ + "static/img/logo.846e8e97.png";